"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BadgeNumber = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
require("./badgeNumber.css");
/** A badge number is a tag with a number inside, that we add to an item (e.g. a tab) to make the number stands out. */
const BadgeNumber = ({ size = 'normal', appearance = 'primary', className, children, dataTest = 'badgeNumber', ...other }) => {
    const classes = (0, classnames_1.default)('dsc-badgeNumber', size !== 'normal' && `is-${size}`, appearance !== 'primary' && `is-${appearance}`, className);
    return ((0, jsx_runtime_1.jsx)("div", { ...other, className: classes, "data-test": dataTest, children: children }));
};
exports.BadgeNumber = BadgeNumber;
exports.BadgeNumber.displayName = 'BadgeNumber';
//# sourceMappingURL=badgeNumber.js.map